import React from 'react'
import { Prompt } from 'react-router-dom'

import { Box, Card, Typography, Button } from '@material-ui/core'

import Package from './Package'

import useOfferSetupPage, { useStyles } from '../useOfferSetupPage'

import CustomerInfoForm from '~/customer/components/CustomerInfoForm'
import PATHS from '~/router/paths'
import { LineTypes } from '~/tariff/model/tariff.model'

export default function PostpaidOfferSetup() {
  const {
    wrapper,
    deletePackage,
    addAdditionalLine,
    onCloseModal,
    isRestartModal,
    selectResetSaleModalMessage,
    additionalLines,
    onSubmit,
    isCustomerValid,
    deleteClientSearchAddress,
  } = useOfferSetupPage({ nextRoute: PATHS.BILLING })

  const { border, overlay } = useStyles()

  return (
    <div data-hook="offer-setup-page" ref={wrapper}>
      <Box mb="24px">
        <CustomerInfoForm />
      </Box>
      <Package
        id={LineTypes.MAIN}
        shouldDisable={!isCustomerValid}
        onDeleteClientSearchAddress={deleteClientSearchAddress}
      />
      {Object.keys(additionalLines).map((lineId) => (
        <Package
          id={lineId}
          key={lineId}
          onDelete={deletePackage}
          shouldDisable={!isCustomerValid}
        />
      ))}
      <Box mb="24px" position="relative">
        <Card elevation={isCustomerValid ? 5 : 0} className={border}>
          <Box my="21px" mx="24px">
            <Typography variant="h3" onClick={addAdditionalLine} data-hook="add-additional-line">
              + Añadir otra línea
            </Typography>
          </Box>
        </Card>
        {!isCustomerValid && <div data-hook="add-line-disabled" className={overlay} />}
      </Box>
      <Prompt
        message={(location) => {
          onCloseModal()
          if (location.pathname === PATHS.SALES_START && !isRestartModal) {
            selectResetSaleModalMessage('RESTART_SALE')
            return false
          }
          return true
        }}
      />
      <Button
        data-hook="continue-btn"
        type="submit"
        variant="contained"
        color="secondary"
        onClick={onSubmit}
      >
        Continuar
      </Button>
      <Box mx={4} display="inline-block">
        <Button
          data-hook="back-btn"
          variant="outlined"
          color="secondary"
          onClick={() => selectResetSaleModalMessage('RESTART_SALE')}
        >
          Atrás
        </Button>
      </Box>
    </div>
  )
}
